import { renderAlert } from "../../CommonComponents/Alert/Alert";
import { GET, POST } from "../../service/axiosMethods";
import ACTION_TYPES from "../types";
import { deleteWorkbook } from "./workbookAction";

export const saveTemplate = (templateData) => async (dispatch) => {
    try {
        const res = await POST(`/template/create`, templateData);

        if (res.status === 201 && res.data) {
            // Dispatch Redux action to store the new template
            dispatch({
                type: ACTION_TYPES.CREATE_TEMPLATE,
                payload: res.data,
            });

            renderAlert('Template created successfully!', 'success');
        } else {
            renderAlert('Error in creating the template', 'error');
        }
    } catch (error) {
        console.log("Error in saving template", error);
        renderAlert('Error in saving the template', 'error');
    }
};

export const fetchTemplates = () => async (dispatch) => {
  try {
    const res = await GET("/template");
    if (res.status === 200 && res.data) {
      dispatch({
        type: ACTION_TYPES.SET_TEMPLATE_DATA,
        payload: res.data,
      });
    } else {
      throw new Error("Error in fetching templates");
    }
  } catch (error) {
    console.log("error",error)
    console.error("Error in fetching templates:", error);
  }
};



export const deleteTemplate = (template) => async (dispatch) => {
    try {
      const res = await POST(`/template/delete`, { id: template.template_id
 });

      if (res.data.success === true) {
        dispatch({ type: ACTION_TYPES.DELETE_TEMPLATE, payload: template.template_id });
        renderAlert("Template deleted successfully!", "success");
      } else {
        throw new Error();
      }
    } catch (error) {
      console.error("Error deleting template:", error);
      renderAlert("Failed to delete the template.", "error");
    }
  };